import { MatDividerModule } from '@angular/material/divider';
import { CbHouseLandModule } from '@app/views/house-land/house-land.module';
import { HouseAndLandSearchFilterComponent } from './house-and-land-search-filter/house-and-land-search-filter.component';
import { HouseAndLandSearchComponent } from './house-and-land-search/house-and-land-search.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CbCurrencyModule } from '@app/shared/pipe/currency/currency.module';
import { HouseAndLandComponent } from './house-and-land/house-and-land.component';
import { HouseAndLandCardComponent } from './house-and-land-card/house-and-land-card.component';
import { CbAmenitiesModule } from '@app/shared/components/amenities/amenities.module';
import { CbDisplayValueModule } from '@app/shared/components/display-value/display-value.module';
import { CbHandleInvalidImageModule } from '@app/shared/directives/handle-invalid-image/handle-invalid-image.module';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import {CbDasherModule, CbInfoMessageModule, CbLoadingSpinnerModule} from 'cb-hub-lib';
import {MatInputModule} from '@angular/material/input';

@NgModule({
    declarations: [
        HouseAndLandComponent,
        HouseAndLandSearchComponent,
        HouseAndLandSearchFilterComponent,
        HouseAndLandCardComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        InfiniteScrollDirective,
        MatButtonModule,
        MatCardModule,
        MatDividerModule,
        MatInputModule,
        MatChipsModule,
        MatFormFieldModule,
        MatIconModule,
        MatMenuModule,
        MatSelectModule,
        NgxSliderModule,
        ReactiveFormsModule,
        MatTooltipModule,
        CbCurrencyModule,
        CbAmenitiesModule,
        CbDisplayValueModule,
        CbHouseLandModule,
        CbHandleInvalidImageModule,
        CbLoadingSpinnerModule,
        CbDasherModule,
        CbInfoMessageModule,
        RouterModule.forRoot([
            {
                component: HouseAndLandComponent,
                // angular 7+ root routes must start with 'ng'
                path: 'house-and-land',
                data: {
                    breadcrumb: 'House & Land'
                }
            }
        ], {}),

    ],
    exports: [
        HouseAndLandComponent,
        HouseAndLandSearchComponent,
        HouseAndLandSearchFilterComponent,
    ]
})
export class HouseAndLandModule { }
